import React from 'react';
import { Skeleton } from 'antd';

import { LoadErrorEmptyState, WIDGET_LOAD_ERROR_HEADLINES } from '~features/empty-states';

export type CDNAnalyticsChartContainerProps = {
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  noDataFallback: React.ReactNode;
  hasDataForTimeRange?: boolean;
};
function CDNAnalyticsChartContainer({
  isLoading,
  isError,
  onRetry,
  noDataFallback,
  hasDataForTimeRange,
  children,
}: React.PropsWithChildren<CDNAnalyticsChartContainerProps>) {
  const content = isError ? (
    <LoadErrorEmptyState
      screen="cdn_analytics"
      headline={WIDGET_LOAD_ERROR_HEADLINES.chart}
      onRetry={onRetry}
      compact
    />
  ) : hasDataForTimeRange ? (
    children
  ) : (
    noDataFallback
  );

  return (
    <Skeleton loading={isLoading} active paragraph={{ rows: 8 }}>
      {content}
    </Skeleton>
  );
}

export default CDNAnalyticsChartContainer;
